import type { ThemeConfig } from 'antd';

/**
 * Raw Artelia brand colors, exported for direct use in custom components.
 */
export const arteliaColors = {
  bluePrimary: '#005d83',
  textDark: '#212529',
  textLight: '#f1f1f1',
  bgLight: '#f8f9fa',
  
  blueFaded: '#cdecf4',
  blueBright: '#6ac7dd',
  blueDarker: '#005d83',
  
  greenFaded: '#c2e5e0',
  greenBright: '#6bc3b6',
  greenDarker: '#089b86',
  
  purpleFaded: '#ecd3ef',
  purpleBright: '#c77ccf',
  purpleDarker: '#a125af',
  
  yellowFaded: '#fcf1d1',
  yellowBright: '#f5d474',
  yellowDarker: '#efb718',
  
  redFaded: '#f7d3da',
  redBright: '#e67a8f',
  redDarker: '#d62245',

  warningText: '#D83B01',
  warningBg: '#FFF4F0',
};

/**
 * Ant Design Theme Configuration
 * This object configures the look and feel of all Ant Design components.
 * It uses CSS variables defined in `theme.css` as the single source of truth.
 */
export const antdTheme: ThemeConfig = {
  // 1. Global style tokens
  token: {
    // Font
    fontFamily: 'Calibri, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

    // Core Colors
    colorPrimary: arteliaColors.bluePrimary,
    colorSuccess: arteliaColors.greenDarker,
    colorWarning: arteliaColors.yellowDarker,
    colorError: arteliaColors.redDarker,
    colorInfo: arteliaColors.bluePrimary,

    // Text & Background
    colorTextBase: arteliaColors.textDark,
    colorBgLayout: arteliaColors.bgLight, // Page background
    colorBgContainer: '#ffffff', // Card, Panel, Modal backgrounds

    // Sizing
    borderRadius: 8,
    controlHeight: 36, // Buttons, Inputs
    headerHeight: 64, // Header component height
  },

  // 2. Component-specific overrides
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#ffffff',
      headerHeight: 64,
      headerPadding: '0 24px',
    },
    Card: {
      // Use the custom, on-brand shadow
      boxShadow: '0 4px 6px -1px rgba(0, 93, 131, .08), 0 2px 4px -1px rgba(0, 93, 131, .04)',
      paddingLG: 16, // Smaller padding for a tighter look
    },
    Tag: {
      // Tags will have no border for a softer, modern appearance
      defaultBg: '#f0f0f0',
      defaultColor: '#595959',
    },
    Button: {
      // Make primary buttons slightly bolder
      fontWeight: 600,
    },
  },
};
